import ContactUs from '../../contact_us/ContactUs.vue'

export default {
    components: { 
        ContactUs
    },

    data: () => ({
        componentSelected: null,
        customItemsContactUs: {}
    }),

    created(){
        this.customItemsContactUs = this.DATACUSTOM.text
    },

    methods: {
        selectComponent() {
            this.componentSelected = ContactUs
            this.$root.$emit('selectComponent', {
                componentSelected: this.componentSelected,
                customItems: this.customItemsContactUs
            })
        }
    }
}